// extracted by mini-css-extract-plugin
module.exports = {"main":"InsightExperienceCard_main__RKYI4","link":"InsightExperienceCard_link__5NOqc","icon":"InsightExperienceCard_icon__TDbnz","footer":"InsightExperienceCard_footer__zokNe"};